import { gql } from "@apollo/client";

export const GET_LOCATIONS = gql`
  query GetLocations {
    locations {
      id
      name
      description
      photo
    }
  }
`;

export const REGISTER_USER = gql`
  mutation RegisterUser($credentials: RegisterCredentials!) {
    register(credentials: $credentials) {
      id
      email
    }
  }
`;

export const WEB3_REGISTER_USER = gql`
  mutation RegisterUser($credentials: RegisterCredentials!) {
    register(credentials: $credentials) {
      id
      email
      firstName
      lastName
      siweNonce
      walletAddress
    }
  }
`;

export const LOGIN_USER = gql`
  mutation LoginUser($credentials: Credentials!) {
    login(credentials: $credentials) {
      id
      username
      email
      isEmailVerified
      accessToken
    }
  }
`;

export const VERIFY_EMAIL = gql`
  mutation VerifyEmail($credentials: VerifyEmailCredentials!) {
    verifyEmail(credentials: $credentials) {
      id
      username
      email
      password
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($credentials: ForgetPasswordCredentials!) {
    resetPassword(credentials: $credentials) {
      email
      message
    }
  }
`;

export const FORGET_PASSWORD = gql`
  mutation ForgetPassword($credentials: RequestForgetPasswordCredentials!) {
    forgetPassword(credentials: $credentials) {
      email
      message
    }
  }
`;

export const GET_ALL_USERS = gql`
  query getAllUsers(
    $orderBy: [UserOrderByInput!]
    $skip: Float
    $take: Float
    $where: UserWhereInput
  ) {
    users(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      firstName
      lastName
      email
      isEmailVerified
      username
      userType
      userOnboardingStatus
      roles
      userDriverKYC
      driverLicenseIdentifier
      isUnderAgeDriver
    }
  }
`;

export const USER_NAME_UPDATE = gql`
  mutation UserNameUpdate(
    $data: UserUpdateInput!
    $where: UserWhereUniqueInput!
  ) {
    updateUserNames(data: $data, where: $where) {
      id
      username
      email
      roles
      accessToken
    }
  }
`;

export const GET_USER_DETAILS = gql`
  query getUser($where: UserWhereUniqueInput!) {
    user(where: $where) {
      id
      firstName
      lastName
      email
      isEmailVerified
      username
      userType
      userOnboardingStatus
      roles
      dateOfBirth
      driverLicense {
        address
        createdAt
        dateOfBirth
        expiryDate
        gender
        id
        expiryDate
        issuedDate
        issuedState
        licenseNumber
        name
      }
      userDriverKYC
      driverLicenseIdentifier
      isUnderAgeDriver
      ecobookProfile {
        bio
        coverImage
        gender
        nickname
        profileImage
        quotes
        socialLink
        website
      }
      cars {
        capacity
        carImages {
          imageUrl
          videoUrl
        }
        color
        createdAt
        extraFeatures
        id
        insuranceExpDate
        insuranceEffectiveDate
        insuranceProvider
        insuranceProviderNumber
        make
        millagePerCharge
        pricePerHour
        model
        policyNumber
        registrationInfo
        rentals {
          createdAt
        }
        seats
        updatedAt
        vehicleType
        vehicleBrand
        year
      }
      notifications {
        createdAt
        id
        isRead
        message
        updatedAt
      }
      rentals {
        car {
          carImages {
            imageUrl
            videoUrl
          }
          color
          id
          lessor {
            username
            id
            firstName
            lastName
            email
          }
          make
          model
          vehicleBrand
          vehicleType
        }
        escrows {
          depositAmount
        }
        createdAt
        currentLocation
        destination
        destinationGeoLoc
        id
        pickupAddress
        pickupGeoLoc
        pickupTime
        rentalEndDatetime
        rentalRequestTime
        rentalStartDatetime
        rentalStatus
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($data: UserUpdateInput!, $where: UserWhereUniqueInput!) {
    updateUser(data: $data, where: $where) {
      id
      firstName
      lastName
      email
      isEmailVerified
      username
      userType
      userOnboardingStatus
      roles
      userDriverKYC
      cars {
        capacity
        carImages {
          imageUrl
          videoUrl
        }
        color
        createdAt
        extraFeatures
        id
        insuranceExpDate
        insuranceEffectiveDate
        insuranceProvider
        insuranceProviderNumber
        make
        millagePerCharge
        pricePerHour
        model
        policyNumber
        registrationInfo
        rentals {
          createdAt
        }
        seats
        updatedAt
        vehicleType
        vehicleBrand
        year
      }
      notifications {
        createdAt
        id
        isRead
        message
        updatedAt
      }
      rentals {
        car {
          carImages {
            imageUrl
            videoUrl
          }
          color
          id
          lessor {
            username
            id
            firstName
            lastName
            email
          }
          make
          model
          vehicleBrand
          vehicleType
        }
        escrows {
          depositAmount
        }
        createdAt
        currentLocation
        destination
        destinationGeoLoc
        id
        pickupAddress
        pickupGeoLoc
        pickupTime
        rentalEndDatetime
        rentalRequestTime
        rentalStartDatetime
        rentalStatus
      }
      ecobookProfile {
        bio
        coverImage
        gender
        nickname
        profileImage
        quotes
        socialLink
        website
      }
    }
  }
`;

export const UPDATE_KYC = gql`
  mutation UpdateKYC(
    $data: UserVerifyKYCInput!
    $where: UserWhereUniqueInput!
  ) {
    updateKYC(data: $data, where: $where) {
      id
    }
  }
`;

export const UPDATE_USER_NAMES = gql`
  mutation UpdateUserNames(
    $data: UpdateUserPasswordInput!
    $where: UserWhereUniqueInput!
  ) {
    updateUserNames(data: $data, where: $where) {
      email
      id
      roles
      username
    }
  }
`;

export const PROFILE_DETAILS = gql`
  query User($where: UserWhereUniqueInput!) {
    user(where: $where) {
      driverLicense {
        address
        dateOfBirth
        expiryDate
        gender
        issuedDate
        issuedState
        licenseNumber
        name
      }
      id
      username
      firstName
      lastName
      email
      phone
      ecobookProfile {
        bio
        coverImage
        gender
        nickname
        profileImage
        quotes
        socialLink
        website
      }
    }
  }
`;

export const UPDATE_PROFILE_DETAILS = gql`
  mutation UpdateUser($data: UserUpdateInput!, $where: UserWhereUniqueInput!) {
    updateUser(data: $data, where: $where) {
      ecobookProfile {
        bio
        coverImage
        gender
        nickname
        profileImage
        quotes
        socialLink
        website
      }
    }
  }
`;

export const ADD_CAR = gql`
  mutation createCar($data: CarCreateInput!) {
    createCar(data: $data) {
      id
      capacity
      carImages {
        createdAt
        id
        car
        imageUrl
        videoUrl
      }
      color
      createdAt
      extraFeatures
      id
      insuranceExpDate
      insuranceEffectiveDate
      insuranceProvider
      insuranceProviderNumber
      lessor
      make
      millagePerCharge
      model
      policyNumber
      registrationInfo
      seats
      vehicleBrand
      VehicleType
      year
      updatedAt
    }
  }
`;

export const ADD_CAR_MUTATION = gql`
  mutation AddCar($data: CarCreateInput!) {
    createCar(data: $data) {
      availability
      capacity
      carImages {
        createdAt
        id
        imageUrl
        videoUrl
      }
      color
      createdAt
      extraFeatures
      id
      fairMarketValue
      hadAccident
      iAmVehicleOwner
      insuranceExpDate
      insuranceEffectiveDate
      insuranceProvider
      insuranceProviderNumber
      isLuxuryVehicle
      lessor {
        id
        username
      }
      make
      millagePerCharge
      model
      parkedLocation
      policyNumber
      registrationInfo
      seats
      vehicleBrand
      vehicleHasMaintenance
      vehicleHasUpdatedMOT
      vehicleType
      vehicleCategory {
        id
      }
      vin
      year
    }
  }
`;

export const ADD_CAR_IMAGES = gql`
  mutation CreateCarImage($data: CarImageCreateInput!) {
    createCarImage(data: $data) {
      carId {
        id
      }
      createdAt
      id
      imageUrl
      videoUrl
      updatedAt
    }
  }
`;

export const DELETE_CAR_IMAGES = gql`
  mutation DeleteCarImage($where: CarImageWhereUniqueInput!) {
    deleteCarImage(where: $where) {
      id
    }
  }
`;

export const UPDATE_CAR = gql`
  mutation UpdateCar($data: CarUpdateInput!, $where: CarWhereUniqueInput!) {
    updateCar(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_CAR = gql`
  mutation DeleteCar($where: CarWhereUniqueInput!) {
    deleteCar(where: $where) {
      id
    }
  }
`;

export const GET_CARS = gql`
  query cars(
    $orderBy: [CarOrderByInput!]
    $where: CarWhereInput
    $take: Float
  ) {
    cars(orderBy: $orderBy, where: $where, take: $take) {
      availability
      reservedDates
      description
      capacity
      carImages {
        createdAt
        id
        imageUrl
        videoUrl
      }
      carRatings {
        accuracy
        cleanliness
        comment
        communication
        deletedAt
        id
        maintenance
        meanRating
        ratedBy {
          firstName
          lastName
          email
          id
        }
        updatedAt
        createdAt
      }
      color
      createdAt
      extraFeatures
      id
      plan {
        id
      }
      hadAccident
      iAmVehicleOwner
      insuranceExpDate
      insuranceEffectiveDate
      insuranceProvider
      insuranceImage
      insuranceProviderNumber
      isLuxuryVehicle
      lessor {
        id
        username
        firstName
        lastName
      }
      make
      millagePerCharge
      model
      parkedLocation
      pricePerHour
      policyNumber
      registrationInfo
      seats
      vehiclePlateNumber
      smartCarVehicleId
      vehicleBrand
      vehicleHasMaintenance
      vehicleHasUpdatedMOT
      vehicleType
      vin
      year
      rentals {
        createdAt
        destinationGeoLoc
        id
        pickupAddress
        escrows {
          id
          depositAmount
        }
        pickupGeoLoc
        rentalEndDatetime
        rentalRequestTime
        rentalStartDatetime
        updatedAt
        rentalStatus
        lessee {
          id
        }
      }

      web3Data {
        lessorAddress
        nftId
        transactionHash
        vehicleId
      }
      vehicleCategory {
        description
        id
        maxAmount
        minAmount
        minAge
        name
        percentageIncrease
        updatedAt
      }
    }
  }
`;

export const VALIDATE_VEHICLE_INPUT = gql`
  query cars(
    $orderBy: [CarOrderByInput!]
    $where: CarWhereInput
    $take: Float
  ) {
    cars(orderBy: $orderBy, where: $where, take: $take) {
      id
    }
  }
`;

export const UPDATE_VEHICLE_PLAN = gql`
  mutation UpdateVehiclePlan($planId: String!, $vehicleId: String!) {
    updateVehiclePlan(planId: $planId, vehicleId: $vehicleId) {
      id
    }
  }
`;

export const GET_CAR = gql`
  query car($where: CarWhereUniqueInput!) {
    car(where: $where) {
      availability
      reservedDates
      description
      capacity
      carImages {
        createdAt
        id
        imageUrl
        videoUrl
      }
      carRatings {
        accuracy
        cleanliness
        comment
        communication
        deletedAt
        id
        maintenance
        meanRating
        ratedBy {
          firstName
          lastName
          email
          id
        }
        updatedAt
        createdAt
      }
      color
      createdAt
      extraFeatures
      id
      plan {
        id
      }
      hadAccident
      iAmVehicleOwner
      insuranceExpDate
      insuranceEffectiveDate
      insuranceProvider
      insuranceImage
      insuranceProviderNumber
      isLuxuryVehicle
      lessor {
        id
        username
        firstName
        lastName
      }
      make
      millagePerCharge
      model
      parkedLocation
      pricePerHour
      policyNumber
      registrationInfo
      seats
      vehiclePlateNumber
      smartCarVehicleId
      vehicleBrand
      vehicleHasMaintenance
      vehicleHasUpdatedMOT
      vehicleType
      vin
      year
      rentals {
        createdAt
        destinationGeoLoc
        id
        pickupAddress
        escrows {
          id
          depositAmount
        }
        pickupGeoLoc
        rentalEndDatetime
        rentalRequestTime
        rentalStartDatetime
        updatedAt
        rentalStatus
        lessee {
          id
        }
      }

      web3Data {
        lessorAddress
        nftId
        transactionHash
        vehicleId
      }
      vehicleCategory {
        description
        id
        maxAmount
        minAmount
        minAge
        name
        percentageIncrease
        updatedAt
      }
    }
  }
`;

export const CREATE_RENTAL = gql`
  mutation RentCar($data: RentalCreateInput!) {
    createRental(data: $data) {
      car {
        id
      }
      createdAt
      currentLocation
      destination
      destinationGeoLoc
      escrows {
        blockchainHash
        depositAmount
        depositStatus
        id
      }
      id
      lessee {
        id
      }
      pickupAddress
      pickupGeoLoc
      pickupTime
      plan {
        id
      }
      rentalEndDatetime
      rentalRequestTime
      rentalStartDatetime
      rentalStatus
      updatedAt
    }
  }
`;

export const UPDATE_RENTAL = gql`
  mutation updateRental(
    $data: RentalUpdateInput!
    $where: RentalWhereUniqueInput!
  ) {
    updateRental(data: $data, where: $where) {
      car {
        id
      }
      createdAt
      currentLocation
      destination
      destinationGeoLoc
      escrows {
        blockchainHash
        depositAmount
        depositStatus
        id
      }
      id
      lessee {
        id
      }
      pickupAddress
      pickupGeoLoc
      pickupTime
      plan {
        id
      }
      rentalEndDatetime
      rentalRequestTime
      rentalStartDatetime
      rentalStatus
      updatedAt
    }
  }
`;

export const GET_RENTALS = gql`
  query rentals($orderBy: [RentalOrderByInput!], $where: RentalWhereInput) {
    rentals(orderBy: $orderBy, where: $where) {
      car {
        capacity
        carImages {
          createdAt
          id
          imageUrl
          videoUrl
          updatedAt
        }
        availability
        vin
        parkedLocation
        createdAt
        extraFeatures
        id
        insuranceEffectiveDate
        insuranceExpDate
        insuranceProviderNumber
        insuranceProvider
        lessor {
          username
          id
          firstName
          lastName
          email
        }
        make
        millagePerCharge
        model
        vehicleType
        vehicleBrand
        policyNumber
        registrationInfo
        color
        smartCarVehicleId

        vehiclePlateNumber
        year
      }
      createdAt
      currentLocation
      destination
      destinationGeoLoc
      escrows {
        blockchainHash
        depositAmount
        depositStatus
        id
      }
      id
      lessee {
        id
        firstName
        lastName
        email
      }
      pickupAddress
      pickupGeoLoc
      pickupTime
      plan {
        id
      }
      rentalEndDatetime
      rentalRequestTime
      rentalStartDatetime
      rentalStatus
      updatedAt
    }
  }
`;

export const GET_RENTAL = gql`
  query rental($where: RentalWhereUniqueInput!) {
    rental(where: $where) {
      car {
        capacity
        carImages {
          createdAt
          id
          imageUrl
          videoUrl
          updatedAt
        }
        availability
        vin
        parkedLocation
        createdAt
        extraFeatures
        id
        insuranceEffectiveDate
        insuranceExpDate
        insuranceProviderNumber
        insuranceProvider
        lessor {
          username
          id
          firstName
          lastName
          email
        }
        make
        millagePerCharge
        model
        vehicleType
        vehicleBrand
        policyNumber
        registrationInfo
        color
        vehiclePlateNumber
      }
      createdAt
      currentLocation
      destination
      destinationGeoLoc
      escrows {
        blockchainHash
        depositAmount
        depositStatus
        id
      }
      id
      lessee {
        id
      }
      pickupAddress
      pickupGeoLoc
      pickupTime
      plan {
        id
      }
      rentalEndDatetime
      rentalRequestTime
      rentalStartDatetime
      rentalStatus
      updatedAt
    }
  }
`;

export const CREATE_ESCROW = gql`
  mutation CreateEscrow($data: EscrowCreateInput!) {
    createEscrow(data: $data) {
      id
      depositAmount
      depositStatus
      blockchainHash
      rentalId {
        id
      }
    }
  }
`;

export const CREATE_PLAN = gql`
  mutation CreatePlan($data: PlanCreateInput!) {
    createPlan(data: $data) {
      id
      name
      createdAt
      updatedAt
      rentals {
        createdAt
        destination
        destinationGeoLoc
        id
        pickupAddress
        pickupGeoLoc
        rentalEndDatetime
        rentalRequestTime
        rentalStartDatetime
        rentalStatus
        updatedAt
      }
    }
  }
`;

export const CREATE_COMMUNITY = gql`
  mutation CreateCommunity($data: CommunityCreateInput) {
    createCommunity(data: $data) {
      communityFeeds {
        comments {
          createdAt
          id
          updatedAt
        }
        content
        createdAt
        id
        updatedAt
      }
      communityHeaderImgUrl
      createdAt
      description
      id
      creator {
        id
        firstName
        lastName
        username
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      members {
        cars {
          id
          capacity
          color
          createdAt
          extraFeatures
          insuranceExpDate
          insuranceEffectiveDate
          insuranceProvider
          insuranceProviderNumber
          lessorId {
            id
            username
          }
          carImages {
            imageUrl
            videoUrl
          }
          make
          millagePerCharge
          model
          policyNumber
          registrationInfo
          seats
          updatedAt
          availability
          vin
          parkedLocation
          hadAccident
          iAmVehicleOwner
          vehicleHasMaintenance
          vehicleHasUpdatedMOT
          Web3Data
          year
        }
        createdAt
        email
        emailToken
        roles
      }
      name
      updatedAt
    }
  }
`;

//New community create mutation
export const COMMUNITY_CREATE = gql`
  mutation CreateCommunity($data: CommunityCreateInput!) {
    createCommunity(data: $data) {
      communityFeeds {
        community {
          id
          name
          description
          members {
            id
            username
            lastName
            firstName
            ecobookProfile {
              bio
              coverImage
              gender
              nickname
              profileImage
              quotes
              socialLink
              website
            }
          }
          communityHeaderImgUrl
        }
        feedBackground
        content
        createdAt
        creator {
          id
          username
          lastName
          firstName
        }
        id
        mediaUrl {
          imageUrl
          videoUrl
        }
        feedLikes {
          id
          likedBy {
            id
          }
        }
        comments {
          comments
          communityFeed {
            id
          }
          creator {
            id
            username
            lastName
            firstName
            ecobookProfile {
              bio
              coverImage
              gender
              nickname
              profileImage
              quotes
              socialLink
              website
            }
          }
          createdAt
        }
      }
      communityHeaderImgUrl
      createdAt
      creator {
        id
        username
        lastName
        firstName
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      id
      name
      updatedAt
      members {
        id
        username
        firstName
        lastName
        email
        createdAt
        roles
      }
      moderators {
        id
        username
        firstName
        lastName
        email
        createdAt
        roles
      }
    }
  }
`;

//delete community
export const DELETE_COMMUNITY = gql`
  mutation DeleteCommunity($where: CommunityWhereUniqueInput!) {
    deleteCommunity(where: $where) {
      id
    }
  }
`;

export const GET_COMMUNITIES = gql`
  query Communities(
    $orderBy: [CommunityOrderByInput!]
    $where: CommunityWhereInput
    $take: Float
    $skip: Float
  ) {
    communities(orderBy: $orderBy, where: $where, take: $take, skip: $skip) {
      communityFeeds {
        feedBackground
        feedLikes {
          id
        }
        comments {
          id
          updatedAt
          createdAt
          comments
        }
        content
        createdAt
        id
        updatedAt
        mediaUrl {
          imageUrl
          videoUrl
        }
        community {
          id
        }
      }
      creator {
        id
        lastName
        firstName
        username
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      communityHeaderImgUrl
      createdAt
      description
      id
      members {
        id
        username
        email
        firstName
        lastName
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      name
      updatedAt
    }
  }
`;

export const CREATE_COMMUNITY_FEED = gql`
  mutation CreateCommunityFeed($data: CommunityFeedCreateInput!) {
    createCommunityFeed(data: $data) {
      community {
        id
        description
        communityHeaderImgUrl
        name
        members {
          id
          username
          email
          ecobookProfile {
            bio
            coverImage
            gender
            nickname
            profileImage
            quotes
            socialLink
            website
          }
        }
        name
      }
      feedBackground
      content
      creator {
        id
        username
        email
        firstName
        lastName
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      feedLikes {
        likedBy {
          id
          username
          lastName
          firstName
        }
      }
      id
      mediaUrl {
        imageUrl
        videoUrl
      }
    }
  }
`;

export const GET_MEDIAS = gql`
  query Media($where: MediaWhereUniqueInput!) {
    media(where: $where) {
      imageUrl
      videoUrl
      createdBy
      communittFeed {
        id
      }
      id
    }
  }
`;

export const CREATE_FEED_COMMENT = gql`
  mutation CreateComment($data: CommentCreateInput!) {
    createComment(data: $data) {
      comments
      creator {
        id
        email
        username
        firstName
        lastName
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      id
      communityFeed {
        id
      }
      userFeed {
        id
      }
    }
  }
`;

export const CREATE_COMMENT_REPLY = gql`
  mutation CreateCommentReply($data: CommentReplyCreateInput!) {
    createCommentReply(data: $data) {
      message
      commentBy {
        firstName
      }
    }
  }
`;

export const GET_COMMENT_REPLY = gql`
  query CommentReplys(
    $where: CommentReplyWhereInput
    $take: Float
    $orderBy: [CommentReplyOrderByInput!]
  ) {
    commentReplys(where: $where, take: $take, orderBy: $orderBy) {
      message
      commentBy {
        id
        firstName
        lastName
        username
        ecobookProfile {
          profileImage
        }
      }
      createdAt
      id
    }
  }
`;

export const UPDATE_COMMENT_REPLY = gql`
  mutation UpdateCommentReply(
    $data: CommentReplyUpdateInput!
    $where: CommentReplyWhereUniqueInput!
  ) {
    updateCommentReply(data: $data, where: $where) {
      message
      commentBy {
        firstName
      }
      id
    }
  }
`;
export const DELETE_COMMENT_REPLY = gql`
  mutation DeleteCommentReply($where: CommentReplyWhereUniqueInput!) {
    deleteCommentReply(where: $where) {
      message
      id
    }
  }
`;

export const CREATE_COMMENT_LIKE = gql`
  mutation CreateCommentLike($data: CommentLikeCreateInput!) {
    createCommentLike(data: $data) {
      comment {
        id
      }
      createdAt
      id
      user {
        id
        username
        firstName
        lastName
      }
    }
  }
`;

export const GET_COMMENT_LIKE = gql`
  query CommentLike($where: CommentLikeWhereUniqueInput!) {
    commentLike(where: $where) {
      comment {
        id
      }
      createdAt
      id
      user {
        id
        username
        firstName
        lastName
      }
    }
  }
`;

export const DELETE_COMMENT_LIKE = gql`
  mutation DeleteCommentLike($where: CommentLikeWhereUniqueInput!) {
    deleteCommentLike(where: $where) {
      id
    }
  }
`;

export const CREATE_FEED_LIKES = gql`
  mutation FeedLike($data: FeedLikeCreateInput!) {
    createFeedLike(data: $data) {
      communityFeed {
        id
        creator {
          id
          username
          firstName
          lastName
        }
      }
      likedBy {
        id
        username
        firstName
        lastName
      }
      userFeed {
        id
        creator {
          id
          username
          firstName
          lastName
        }
      }
      id
    }
  }
`;

export const DELETE_FEED_LIKES = gql`
  mutation DeleteFeedLikes($where: FeedLikeWhereUniqueInput!) {
    deleteFeedLike(where: $where) {
      id
    }
  }
`;
export const GET_FEED_LIKES = gql`
  query FeedLikes($where: FeedLikeWhereInput) {
    feedLikes(where: $where) {
      id
      communityFeed {
        id
        mediaUrl {
          imageUrl
          videoUrl
        }
        content
        community {
          name
          id
        }
        feedLikes {
          id
          likedBy {
            firstName
          }
        }
      }
      likedBy {
        id
        firstName
        lastName
        username
      }
      userFeed {
        id
        creator {
          id
          username
          firstName
          lastName
        }
        media {
          imageUrl
          videoUrl
        }
      }
    }
  }
`;
export const DELETE_COMMUNITY_FEED = gql`
  mutation DeleteCommunityFeed($where: CommunityFeedWhereUniqueInput!) {
    deleteCommunityFeed(where: $where) {
      id
    }
  }
`;

export const GET_FEEDS_COMMENTS = gql`
  query Comments($orderBy: [CommentOrderByInput!], $where: CommentWhereInput) {
    comments(orderBy: $orderBy, where: $where) {
      id
      comments
      createdAt
      communityFeed {
        id
      }
      creator {
        id
        username
        lastName
        firstName
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      updatedAt
      userFeed {
        id
      }
      commentLikes {
        comment {
          id
        }
        createdAt
        id
        user {
          firstName
          lastName
          id
        }
      }
    }
  }
`;

export const GET_COMMUNITY_FEEDS = gql`
  query GetCommunityFeeds(
    $orderBy: [CommunityFeedOrderByInput!]
    $where: CommunityFeedWhereInput
    $take: Float
    $skip: Float
  ) {
    communityFeeds(orderBy: $orderBy, where: $where, take: $take, skip: $skip) {
      content
      id
      createdAt
      mediaUrl {
        imageUrl
        videoUrl
      }
      feedBackground
      feedLikes {
        id
        communityFeed {
          id
          mediaUrl {
            imageUrl
            videoUrl
          }
        }
        userFeed {
          id
          media {
            imageUrl
            videoUrl
          }
        }
        likedBy {
          id
          username
          lastName
          firstName
        }
      }
      community {
        id
        name
      }
      creator {
        id
        email
        username
        lastName
        firstName
        roles
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      comments {
        commentLikes {
          comment {
            id
          }
          createdAt
          id
          user {
            firstName
            lastName
            id
          }
        }
        comments
        creator {
          id
          email
          username
          firstName
          lastName
          ecobookProfile {
            bio
            coverImage
            gender
            nickname
            profileImage
            quotes
            socialLink
            website
          }
        }
        id
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_FEED_COMMENT = gql`
  mutation DeleteCommunityFeedComment($where: CommentWhereUniqueInput!) {
    deleteComment(where: $where) {
      id
    }
  }
`;

export const UPDATE_FEED_COMMENT = gql`
  mutation UpdateComment(
    $data: CommentUpdateInput!
    $where: CommentWhereUniqueInput!
  ) {
    updateComment(data: $data, where: $where) {
      comments
      id
      communityFeed {
        id
      }
      creator {
        id
        username
        firstName
        lastName
      }
      updatedAt
      userFeed {
        id
      }
    }
  }
`;

export const UPDATE_COMMUNITY_FEED = gql`
  mutation UpdateCommunityFeed(
    $data: CommunityFeedUpdateInput!
    $where: CommunityFeedWhereUniqueInput!
  ) {
    updateCommunityFeed(data: $data, where: $where) {
      community {
        id
      }
      content
      id
      mediaUrl {
        imageUrl
        videoUrl
      }
    }
  }
`;

//User's Feed Mutation and query starts from here.
export const CREATE_USER_FEED = gql`
  mutation CreateUserFeed($data: UserFeedCreateInput!) {
    createUserFeed(data: $data) {
      content
      feedBackground
      createdAt
      creator {
        id
      }
      id
      media {
        imageUrl
        videoUrl
      }
      comments {
        comments
        createdAt
        creator {
          id
        }
        id
        updatedAt
      }
    }
  }
`;

export const UPDAT_USER_FEED = gql`
  mutation UpdateUserFeed(
    $data: UserFeedUpdateInput!
    $where: UserFeedWhereUniqueInput!
  ) {
    updateUserFeed(data: $data, where: $where) {
      id
      content
      creator {
        id
      }
      media {
        imageUrl
        videoUrl
      }
    }
  }
`;

export const JOIN_COMMUNITY = gql`
  mutation JoinCommunity(
    $data: CommunityJoinOrLeaveInput!
    $where: CommunityWhereUniqueInput!
  ) {
    joinCommunity(data: $data, where: $where) {
      communityFeeds {
        community {
          id
          name
          description
          members {
            id
            username
            lastName
            firstName
          }
          communityHeaderImgUrl
        }
        feedBackground
        content
        createdAt
        creator {
          id
          username
          lastName
          firstName
          ecobookProfile {
            bio
            coverImage
            gender
            nickname
            profileImage
            quotes
            socialLink
            website
          }
        }
        id
        mediaUrl {
          imageUrl
          videoUrl
        }
        feedLikes {
          id
          likedBy {
            id
          }
        }
        comments {
          comments
          communityFeed {
            id
          }
          creator {
            id
            username
            lastName
            firstName
            ecobookProfile {
              bio
              coverImage
              gender
              nickname
              profileImage
              quotes
              socialLink
              website
            }
          }
          createdAt
        }
      }
      communityHeaderImgUrl
      createdAt
      creator {
        id
        username
        lastName
        firstName
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      id
      name
      updatedAt
      members {
        id
        username
        firstName
        lastName
        email
        createdAt
        roles
      }
      moderators {
        id
        username
        firstName
        lastName
        email
        createdAt
        roles
      }
    }
  }
`;

export const LEAVE_COMMUNITY = gql`
  mutation JoinCommunity(
    $data: CommunityJoinOrLeaveInput!
    $where: CommunityWhereUniqueInput!
  ) {
    leaveCommunity(data: $data, where: $where) {
      communityFeeds {
        community {
          id
          name
          description
          members {
            id
            username
            lastName
            firstName
          }
          communityHeaderImgUrl
        }
        feedBackground
        content
        createdAt
        creator {
          id
          username
          lastName
          firstName
        }
        id
        mediaUrl {
          imageUrl
          videoUrl
        }
        feedLikes {
          id
          likedBy {
            id
          }
        }
        comments {
          comments
          communityFeed {
            id
          }
          creator {
            id
            username
            lastName
            firstName
          }
          createdAt
        }
      }
      communityHeaderImgUrl
      createdAt
      creator {
        id
        username
        lastName
        firstName
      }
      id
      name
      updatedAt
      members {
        id
        username
        firstName
        lastName
        email
        createdAt
        roles
      }
      moderators {
        id
        username
        firstName
        lastName
        email
        createdAt
        roles
      }
    }
  }
`;

export const DELETE_USER_FEEDS = gql`
  mutation UserFeed($where: UserFeedWhereUniqueInput!) {
    deleteUserFeed(where: $where) {
      id
    }
  }
`;

export const GET_USER_FEEDS = gql`
  query UserFeeds(
    $orderBy: [UserFeedOrderByInput!]
    $take: Float
    $where: UserFeedWhereInput
    $skip: Float
  ) {
    userFeeds(orderBy: $orderBy, take: $take, where: $where, skip: $skip) {
      content
      feedBackground
      createdAt
      creator {
        firstName
        id
        lastName
        username
        ecobookProfile {
          bio
          coverImage
          gender
          nickname
          profileImage
          quotes
          socialLink
          website
        }
      }
      id
      media {
        imageUrl
        videoUrl
      }
      feedLikes {
        id
      communityFeed {
        id
        mediaUrl {
          imageUrl
          videoUrl
        }
        content
        community {
          name
          id
        }
        feedLikes {
          id
          likedBy {
            firstName
          }
        }
      }
      likedBy {
        id
        firstName
        lastName
        username
      }
      userFeed {
        id
        creator {
          id
          username
          firstName
          lastName
        }
        media {
          imageUrl
          videoUrl
        }}
      }
      comments {
        commentLikes {
          comment {
            id
          }
          createdAt
          id
          user {
            firstName
            lastName
            id
          }
        }
        comments
        createdAt
        creator {
          firstName
          id
          lastName
          username
          ecobookProfile {
            bio
            coverImage
            gender
            nickname
            profileImage
            quotes
            socialLink
            website
          }
        }
        id
        updatedAt
      }
    }
  }
`;
//User's Feed mutation and Query ends here.

export const REQUEST_NONCE = gql`
  query RequestNonce($address: String!) {
    requestNonce(address: $address) {
      nonce
    }
  }
`;

export const VERIFY_SIWE_SIGNATURE = gql`
  mutation VerifySIWESignature($credentials: VerifySIWECredentials!) {
    verifySIWESignature(credentials: $credentials) {
      id
      username
      email
isEmailVerified      
accessToken
    }
  }
`;

export const SMARTCAR_EXCHANGE = gql`
  mutation ExchangeSmartCarCode($data: ExchangeSmartCarCodeInput!) {
    exchange(data: $data) {
      access_token
      expires_in
      refresh_token
      token_type
    }
  }
`;

export const SMARTCAR_GET_ALL_VEHICLES = gql`
  query GetAllVehicles($data: GetSmartCarListedCarInput!) {
    getAllVehicles(data: $data) {
      paging {
        count
        offset
      }
      vehicles
    }
  }
`;

export const SMARTCAR_GET_VEHICLE_DETAILS = gql`
  query GetVehicleDetails($data: GetSmartCarListedCarInput!) {
    getVehicleDetails(data: $data) {
      id
      make
      model
      year
    }
  }
`;

export const SMARTCAR_BATCH_RESPONSE = gql`
  query GetBatchData($accessToken: String!, $vehicleId: String!) {
    getBatchData(accessToken: $accessToken, vehicleId: $vehicleId) {
      responses {
        body
        code
        header
        path
      }
    }
  }
`;

export const SEND_VEHICLE_UNLOCK_OTP = gql`
  mutation SendVehicleUnlockOTP($rentalId: String!) {
    sendVehicleUnlockOTP(rentalId: $rentalId) {
      error
      message
      status
      token
    }
  }
`;

export const VERIFY_VEHICLE_UNLOCK_OTP = gql`
  mutation VerifyVehicleUnlockOTP($rentalId: String!, $token: String!) {
    verifyVehicleUnlockOTP(rentalId: $rentalId, token: $token) {
      error
      message
      status
      token
    }
  }
`;

export const LOCK_VEHICLE = gql`
  mutation LockVehicle($data: SmartCarLockAndUnLockInput!) {
    lockVehicle(data: $data) {
      status
      message
    }
  }
`;

export const UNLOCK_VEHICLE = gql`
  mutation UnLockVehicle($data: SmartCarLockAndUnLockInput!) {
    unLockVehicle(data: $data) {
      status
      message
    }
  }
`;

export const GET_LOCK_STATUS = gql`
  query GetLockStatus($data: SmartCarLockAndUnLockInput!) {
    getLockStatus(data: $data) {
      chargingPort {
        status
        type
      }
      doors {
        status
        type
      }
      isLocked
      storage {
        status
        type
      }
      sunroof {
        status
        type
      }
      windows {
        status
        type
      }
    }
  }
`;

export const LESSEE_GET_BATCH_DATA = gql`
  query LesseeGetBatchData($vehicleId: String!) {
    lesseeGetBatchData(vehicleId: $vehicleId) {
      responses {
        body
        code
        header
        path
      }
    }
  }
`;

export const GET_PLANS = gql`
  query Plans($where: PlanWhereInput) {
    plans(where: $where) {
      features {
        featureId
        value
      }
      id
      isLesseePlan
      minimumAge
      name
    }
  }
`;

export const CREATE_CAR_RATING = gql`
  mutation CreateCarRating($data: CarRatingCreateInput!) {
    createCarRating(data: $data) {
      carId {
        id
      }
      comment
      meanRating
      ratedBy {
        id
      }
    }
  }
`;

export const CAR_CONDITIONAL_PRICE = gql`
  subscription CarConditionalPrice {
    carConditionalPrice {
      id
      pricePerHour
    }
  }
`;

export const CAR_CONDITIONAL_PRICE_SUBSCRIPTION = `
subscription Ds {
  carConditionalPrice {
    id
    pricePerHour
  }
}
`;

export const CREATE_CANCELLED_RENTAL = gql`
  mutation CreateCancelledRental($data: CancelledRentalCreateInput!) {
    createCancelledRental(data: $data) {
      amountPaid
      id
      cancelRequestTime
      reason
      rental {
        id
      }
      rentalEndTime
      rentalRequestTime
      returnedAmount
    }
  }
`;

export const VEHICLE_CATEGORIES = gql`
  query VehicleCategories {
    vehicleCategories {
      description
      id
      maxAmount
      minAmount
      minAge
      name
      percentageIncrease
      updatedAt
    }
  }
`;

export const VEHICLE_CAPACITIES = gql`
  query VehicleCapacities {
    vehicleCapacities {
      id
      capacity
    }
  }
`;

export const VEHICLE_TYPES = gql`
  query VehicleTypes {
    vehicleTypes {
      id
      type
    }
  }
`;

export const VEHICLE_COLORS = gql`
  query VehicleColors {
    vehicleColors {
      id
      color
    }
  }
`;

export const VEHICLE_EXTRA_FEATURES = gql`
  query VehicleExtraFeatures {
    vehicleExtraFeatures {
      id
      feature
    }
  }
`;

export const CREATE_DRIVER_LICENSE = gql`
  mutation CreateDriverLicense($data: CreateDriverLicenseInput!) {
    createDriverLicense(data: $data) {
      address
      dateOfBirth
      expiryDate
      gender
      issuedDate
      issuedState
      licenseNumber
      name
    }
  }
`;

export const RESEND_OTP = gql`
  mutation ResendOTP($credentials: RequestForgetPasswordCredentials!) {
    resendOTP(credentials: $credentials) {
      email
    }
  }
`;
